// ================================================================
// src/routes/AppRoutes.jsx
// ================================================================
// نسخه نهایی و کامل - شامل تمام مسیرهای موجود + مسیرهای جدید
// ================================================================

import React, { useState, useEffect, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';

import TeamDashboard from '../team/TeamDashboard';
import AdminCategoriesPage from '../pages/admin/AdminCategories.jsx';

import PaymentCallbackPage from '../pages/PaymentCallbackPage';

import PaymentReturn from '../freeStudy/PaymentReturn';

import PublicExamsPage from '../components/Exams/PublicExamsPage.jsx';

import TeacherStepQuizEditor from '../pages/teacher/TeacherStepQuizEditor.jsx';
import StepQuizRunner from '../components/books/StepQuizRunner.jsx';
import StepQuizSyncListener from '../components/books/StepQuizSyncListener.jsx';


import WorkbookViewer from '../pages/WorkbookViewer';

import ConvertPage from '../pages/ConvertPage';

import dataEngine from '../core/books/data.js';
import { engine } from '../core/books/storage.js';





// ===== صفحه جدید مراحل یادگیری =====
import LessonStepsPage from '../pages/LessonStepsPage';

//import VideoCoursePage from '../pages/VideoCoursePage';
import CourseDetail from '../pages/CourseDetail';
import CourseVideos from '../pages/CourseVideos';
import BookChapters from '../pages/BookChapters';


// ===== صفحه‌های جدید سیستم کتاب‌های داینامیک =====
import TeacherBooksPage from '../pages/teacher/TeacherBooks.jsx';
import TeacherProjectEditor from '../pages/teacher/TeacherProjectEditor.jsx';
import AdminBooksPage from '../pages/admin/AdminBooks.jsx';
import AdminProjectReview from '../pages/admin/AdminProjectReview.jsx';
import TeacherFreeStudy from '../pages/teacher/TeacherFreeStudy.jsx'; // 🆕
import AdminFreeStudy from '../pages/admin/AdminFreeStudy.jsx'; // 🆕
import AdminUploadPDF from '../pages/admin/AdminUploadPDF.jsx'; 
import AdminTeacherShelf from '../pages/admin/AdminTeacherShelf.jsx'; // 🆕

import WeatherPage from '../pages/WeatherPage.jsx';


//import PrivateClassPage from '../pages/PrivateClassPage';
import StudentPrivateClassPage from '../pages/StudentPrivateClassPage';
import TeacherPrivateClassPage from '../pages/TeacherPrivateClassPage';
import AdminPrivateClassPage from '../pages/AdminPrivateClassPage';

import FreeStudyCourse from '../pages/FreeStudyCourse';

// ============================================================
// ✅ صفحات جدید ۴ نقش (Dashboard اختصاصی هر نقش)
// ============================================================
import StudentHome from '../pages/StudentHome.jsx';
import TeacherHome from '../pages/TeacherHome.jsx';
import ParentHome from '../pages/ParentHome.jsx';
import AdminHome from '../pages/AdminHome.jsx';



// ===== بازی کوییز او کینگ (نسخه جدید) =====
import Game from '../game/Game';

// صفحات عمومی
//import LoginPage from '../pages/LoginPage';
//import Signup from '../pages/Signup';
import Login from '../pages/Login';

// ===== صفحه‌ی خوش‌آمدگویی (Onboarding) =====
import Onboarding from '../components/Onboarding/Onboarding.jsx';

// صفحات آموزشی
import PersianCalendar from '../components/calendar/PersianCalendar';
//import Lessons from '../pages/lessons.jsx';
import Books from '../pages/books.jsx';
import Examsstudent from '../components/Exams/exams-student.jsx';
import Examsteacher from '../components/Exams/exams-teacher.jsx';
import CreateExam from '../components/Exams/CreateExam.jsx';
import TakeExam from '../components/Exams/TakeExam.jsx';
import CreateExamAI from '../components/Exams/CreateExamAI.jsx';
import ExamPdfEditor from '../components/Exams/ExamPdfEditor.jsx';

import AI from '../pages/ai.jsx';

// صفحه سکه‌ها
import CoinsPage from '../components/Coins/CoinsPage.jsx';

// صفحه بازی‌ها
import GamesPage from '../components/Games/GamesPage.jsx';

import LessonPlanning from '../components/Lesson-planning/Lesson-planning.jsx';

//حیوانات خانگی
import GameSanctuary from '../components/pet/GameSanctuary.jsx';

import AILessonGenerator from '../components/ai-lessons/AILessonGenerator.jsx';

// صفحه مدال‌ها
import MedalsPage from '../components/MedalsPage/MedalsPage.jsx';

// صفحات کاربری
//import HomePage from '../pages/home.jsx';
//import Profile from '../pages/profile.jsx';
//import SettingsPage from '../pages/settings.jsx';
import AvatarSettings from '../components/Settings/AvatarSettings.jsx';

// صفحه جزوه درسی
import JozwePage from '../pages/Books-box/jozwe/JozwePage.jsx';
import JozweViewer from '../pages/Books-box/jozwe/JozweViewer.jsx'; // 🆕 اضافه شد

// ============================================================
// ✅ صفحه آرنا چالش‌ها (مسیر جدید)
// ============================================================
import ChallengeArena from '../components/Challenge/ChallengeArena.jsx';

import StudyTimer from '../components/StudyTimer/StudyTimer.jsx';

// محافظت مسیرها
import ProtectedRoute from './ProtectedRoute.jsx';




import UpdateNotification from '../components/UpdateNotification/UpdateNotification';
import AdminAppVersions from '../pages/admin/AdminAppVersions';




// لایه اصلی
import AppLayout from '../layouts/AppLayout.jsx';

import ExamProvider from '../components/Exams/ExamContext.jsx';

import ParentDashboard from '../components/ParentDashboard/ParentDashboard.jsx';

// ============================================================
// ✅ importهای داینامیک برای درس‌ها (به جای import تکی)
// ============================================================
// صفحات اصلی درس‌ها
import RiaziPage from '../pages/classroom/class1/riazi/RiaziPage.jsx';
import RiaziPage2 from '../pages/classroom/class2/riazi/RiaziPage.jsx';
import RiaziPage3 from '../pages/classroom/class3/riazi/RiaziPage.jsx';
import RiaziPage4 from '../pages/classroom/class4/riazi/RiaziPage.jsx';
import RiaziPage5 from '../pages/classroom/class5/riazi/RiaziPage.jsx';
import RiaziPage6 from '../pages/classroom/class6/riazi/RiaziPage.jsx';

import FarsiPage from '../pages/classroom/class1/farsi/FarsiPage.jsx';
import FarsiPage2 from '../pages/classroom/class2/farsi/FarsiPage.jsx';
import FarsiPage3 from '../pages/classroom/class3/farsi/FarsiPage.jsx';
import FarsiPage4 from '../pages/classroom/class4/farsi/FarsiPage.jsx';
import FarsiPage5 from '../pages/classroom/class5/farsi/FarsiPage.jsx';
import FarsiPage6 from '../pages/classroom/class6/farsi/FarsiPage.jsx';

import OlumPage from '../pages/classroom/class1/olum/OlumPage.jsx';
import OlumPage2 from '../pages/classroom/class2/olum/OlumPage.jsx';
import OlumPage3 from '../pages/classroom/class3/olum/OlumPage.jsx';
import OlumPage4 from '../pages/classroom/class4/olum/OlumPage.jsx';
import OlumPage5 from '../pages/classroom/class5/olum/OlumPage.jsx';
import OlumPage6 from '../pages/classroom/class6/olum/OlumPage.jsx';

import GhoranPage from '../pages/classroom/class1/ghoran/GhoranPage.jsx';
import GhoranPage2 from '../pages/classroom/class2/ghoran/GhoranPage.jsx';
import GhoranPage3 from '../pages/classroom/class3/ghoran/GhoranPage.jsx';
import GhoranPage4 from '../pages/classroom/class4/ghoran/GhoranPage.jsx';
import GhoranPage5 from '../pages/classroom/class5/ghoran/GhoranPage.jsx';
import GhoranPage6 from '../pages/classroom/class6/ghoran/GhoranPage.jsx';

import HedyePage2 from '../pages/classroom/class2/hedye/HedyePage.jsx';
import HedyePage3 from '../pages/classroom/class3/hedye/HedyePage.jsx';
import HedyePage4 from '../pages/classroom/class4/hedye/HedyePage.jsx';
import HedyePage5 from '../pages/classroom/class5/hedye/HedyePage.jsx';
import HedyePage6 from '../pages/classroom/class6/hedye/HedyePage.jsx';

import MotaleatPage3 from '../pages/classroom/class3/motaleat/MotaleatPage.jsx';
import MotaleatPage4 from '../pages/classroom/class4/motaleat/MotaleatPage.jsx';
import MotaleatPage5 from '../pages/classroom/class5/motaleat/MotaleatPage.jsx';
import MotaleatPage6 from '../pages/classroom/class6/motaleat/MotaleatPage.jsx';












import ReactDOM from 'react-dom';

// ============================================================
// 🎨 Global Alert Override — یک‌بار برای همیشه، همه‌جا زیبا
// ============================================================

let __gAlertNotify = null;
const __gOrigAlert = window.alert.bind(window);

// ===== Override سراسری window.alert =====
window.alert = (message) => {
  const payload = { message: String(message ?? ''), isConfirm: false };
  if (__gAlertNotify) {
    __gAlertNotify(payload);
  } else {
    __gOrigAlert(payload.message);
  }
};

// ===== Helper برای confirm (چون async هست) =====
window.askConfirm = (message) =>
  new Promise((resolve) => {
    const payload = { message: String(message ?? ''), isConfirm: true, resolve };
    if (__gAlertNotify) {
      __gAlertNotify(payload);
    } else {
      resolve(window.confirm(payload.message));
    }
  });

// ===== کامپوننت GlobalAlertHost =====
const GlobalAlertHost = () => {
  const [state, setState] = React.useState(null);

  React.useEffect(() => {
    __gAlertNotify = (payload) => setState(payload);
    return () => { __gAlertNotify = null; };
  }, []);

  const close = (result) => {
    const resolveFn = state?.resolve;
    setState(null);
    if (resolveFn) resolveFn(result);
  };

  React.useEffect(() => {
    if (!state) return;
    const onKey = (e) => {
      if (e.key === 'Escape') close(state.isConfirm ? false : true);
      if (e.key === 'Enter') close(true);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
    // eslint-disable-next-line
  }, [state]);

  if (!state) return null;

  const isError = /❌|خطا|error|ناموفق|نشد|مشکل/i.test(state.message);
  const isSuccess = /✅|موفق|انجام شد|ثبت شد/i.test(state.message);
  const isWarning = /⚠️|هشدار|توجه|لطفا|باید/i.test(state.message);
  const tone = isError ? 'error' : isSuccess ? 'success' : isWarning ? 'warning' : 'info';
  const icons = { error: '✕', success: '✓', warning: '!', info: 'i' };

  return ReactDOM.createPortal(
    <div
      className="gAlertOverlay"
      dir="rtl"
      onClick={() => !state.isConfirm && close(true)}
    >
      <div className="gAlertBox" onClick={(e) => e.stopPropagation()}>
        <div className={`gAlertBox__icon gAlertBox__icon--${tone}`}>
          {icons[tone]}
        </div>
        <div className="gAlertBox__message">{state.message}</div>
        <div className="gAlertBox__actions">
          {state.isConfirm && (
            <button
              className="gAlertBox__btn gAlertBox__btn--cancel"
              onClick={() => close(false)}
            >
              انصراف
            </button>
          )}
          <button
            className={`gAlertBox__btn gAlertBox__btn--ok gAlertBox__btn--ok-${tone}`}
            onClick={() => close(true)}
          >
            {state.isConfirm ? 'تأیید' : 'باشه'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};










// ============================================================
// ✅ فصل‌های فارسی اول (با استفاده از import داینامیک)
// ============================================================
const farsiLessons = {
  1: () => import('../pages/classroom/class1/farsi/lesson1/Lesson1Review.jsx'),
  2: () => import('../pages/classroom/class1/farsi/lesson1/Lesson2Review.jsx'),
  3: () => import('../pages/classroom/class1/farsi/lesson1/Lesson3Review.jsx'),
  4: () => import('../pages/classroom/class1/farsi/lesson1/Lesson4Review.jsx'),
  5: () => import('../pages/classroom/class1/farsi/lesson1/Lesson5Review.jsx'),
  6: () => import('../pages/classroom/class1/farsi/lesson1/Lesson6Review.jsx'),
  7: () => import('../pages/classroom/class1/farsi/lesson1/Lesson7Review.jsx'),
  8: () => import('../pages/classroom/class1/farsi/lesson1/Lesson8Review.jsx'),
  9: () => import('../pages/classroom/class1/farsi/lesson1/Lesson9Review.jsx'),
  10: () => import('../pages/classroom/class1/farsi/lesson1/Lesson10Review.jsx'),
  11: () => import('../pages/classroom/class1/farsi/lesson1/Lesson11Review.jsx'),
  12: () => import('../pages/classroom/class1/farsi/lesson1/Lesson12Review.jsx'),
  13: () => import('../pages/classroom/class1/farsi/lesson1/Lesson13Review.jsx'),
  14: () => import('../pages/classroom/class1/farsi/lesson1/Lesson14Review.jsx'),
  15: () => import('../pages/classroom/class1/farsi/lesson1/Lesson15Review.jsx'),
  16: () => import('../pages/classroom/class1/farsi/lesson1/Lesson16Review.jsx'),
  17: () => import('../pages/classroom/class1/farsi/lesson1/Lesson17Review.jsx'),
  18: () => import('../pages/classroom/class1/farsi/lesson1/Lesson18Review.jsx'),
  19: () => import('../pages/classroom/class1/farsi/lesson1/Lesson19Review.jsx'),
  20: () => import('../pages/classroom/class1/farsi/lesson1/Lesson20Review.jsx'),
  21: () => import('../pages/classroom/class1/farsi/lesson1/Lesson21Review.jsx'),
  22: () => import('../pages/classroom/class1/farsi/lesson1/Lesson22Review.jsx'),
  23: () => import('../pages/classroom/class1/farsi/lesson1/Lesson23Review.jsx'),
  24: () => import('../pages/classroom/class1/farsi/lesson1/Lesson24Review.jsx'),
  25: () => import('../pages/classroom/class1/farsi/lesson1/Lesson25Review.jsx'),
  26: () => import('../pages/classroom/class1/farsi/lesson1/Lesson26Review.jsx'),
  27: () => import('../pages/classroom/class1/farsi/lesson1/Lesson27Review.jsx'),
  28: () => import('../pages/classroom/class1/farsi/lesson1/Lesson28Review.jsx'),
  29: () => import('../pages/classroom/class1/farsi/lesson1/Lesson29Review.jsx'),
  30: () => import('../pages/classroom/class1/farsi/lesson1/Lesson30Review.jsx'),
  31: () => import('../pages/classroom/class1/farsi/lesson1/Lesson31Review.jsx'),
};

// ============================================================
// ✅ فصل‌های علوم اول
// ============================================================
const olumLessons = {
  1: () => import('../pages/classroom/class1/olum/lesson1/Lesson1Review.jsx'),
  2: () => import('../pages/classroom/class1/olum/lesson1/Lesson2Review.jsx'),
  3: () => import('../pages/classroom/class1/olum/lesson1/Lesson3Review.jsx'),
  4: () => import('../pages/classroom/class1/olum/lesson1/Lesson4Review.jsx'),
  5: () => import('../pages/classroom/class1/olum/lesson1/Lesson5Review.jsx'),
  6: () => import('../pages/classroom/class1/olum/lesson1/Lesson6Review.jsx'),
  7: () => import('../pages/classroom/class1/olum/lesson1/Lesson7Review.jsx'),
  8: () => import('../pages/classroom/class1/olum/lesson1/Lesson8Review.jsx'),
  9: () => import('../pages/classroom/class1/olum/lesson1/Lesson9Review.jsx'),
  10: () => import('../pages/classroom/class1/olum/lesson1/Lesson10Review.jsx'),
  11: () => import('../pages/classroom/class1/olum/lesson1/Lesson11Review.jsx'),
  12: () => import('../pages/classroom/class1/olum/lesson1/Lesson12Review.jsx'),
  13: () => import('../pages/classroom/class1/olum/lesson1/Lesson13Review.jsx'),
  14: () => import('../pages/classroom/class1/olum/lesson1/Lesson14Review.jsx'),
  15: () => import('../pages/classroom/class1/olum/lesson1/Lesson15Review.jsx'),
};

// ============================================================
// ✅ فصل‌های قرآن اول
// ============================================================
const ghoranLessons = {
  1: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson1Review.jsx'),
  2: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson2Review.jsx'),
  3: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson3Review.jsx'),
  4: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson4Review.jsx'),
  5: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson5Review.jsx'),
  6: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson6Review.jsx'),
  7: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson7Review.jsx'),
  8: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson8Review.jsx'),
  9: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson9Review.jsx'),
  10: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson10Review.jsx'),
  11: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson11Review.jsx'),
  12: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson12Review.jsx'),
  13: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson13Review.jsx'),
  14: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson14Review.jsx'),
  15: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson15Review.jsx'),
  16: () => import('../pages/classroom/class1/ghoran/lesson1/Lesson16Review.jsx'),
};

// ============================================================
// ✅ فصل‌های ریاضی اول
// ============================================================
const riaziLessons = {
  1: () => import('../pages/classroom/class1/riazi/lesson1/Lesson1Review.jsx'),
  2: () => import('../pages/classroom/class1/riazi/lesson1/Lesson2Review.jsx'),
  3: () => import('../pages/classroom/class1/riazi/lesson1/Lesson3Review.jsx'),
  4: () => import('../pages/classroom/class1/riazi/lesson1/Lesson4Review.jsx'),
  5: () => import('../pages/classroom/class1/riazi/lesson1/Lesson5Review.jsx'),
  6: () => import('../pages/classroom/class1/riazi/lesson1/Lesson6Review.jsx'),
  7: () => import('../pages/classroom/class1/riazi/lesson1/Lesson7Review.jsx'),
  8: () => import('../pages/classroom/class1/riazi/lesson1/Lesson8Review.jsx'),
  9: () => import('../pages/classroom/class1/riazi/lesson1/Lesson9Review.jsx'),
  10: () => import('../pages/classroom/class1/riazi/lesson1/Lesson10Review.jsx'),
  11: () => import('../pages/classroom/class1/riazi/lesson1/Lesson11Review.jsx'),
  12: () => import('../pages/classroom/class1/riazi/lesson1/Lesson12Review.jsx'),
  13: () => import('../pages/classroom/class1/riazi/lesson1/Lesson13Review.jsx'),
  14: () => import('../pages/classroom/class1/riazi/lesson1/Lesson14Review.jsx'),
  15: () => import('../pages/classroom/class1/riazi/lesson1/Lesson15Review.jsx'),
  16: () => import('../pages/classroom/class1/riazi/lesson1/Lesson16Review.jsx'),
  17: () => import('../pages/classroom/class1/riazi/lesson1/Lesson17Review.jsx'),
  18: () => import('../pages/classroom/class1/riazi/lesson1/Lesson18Review.jsx'),
  19: () => import('../pages/classroom/class1/riazi/lesson1/Lesson19Review.jsx'),
  20: () => import('../pages/classroom/class1/riazi/lesson1/Lesson20Review.jsx'),
  21: () => import('../pages/classroom/class1/riazi/lesson1/Lesson21Review.jsx'),
};

// ============================================================
// ✅ کامپوننت LazyLoad برای بارگذاری داینامیک درس‌ها
// ============================================================
const LessonLoader = ({ lessonMap, lessonId }) => {
  const [Component, setComponent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLesson = async () => {
      try {
        const importer = lessonMap[lessonId];
        if (importer) {
          const module = await importer();
          setComponent(() => module.default || module);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error loading lesson:', error);
        setLoading(false);
      }
    };
    loadLesson();
  }, [lessonId, lessonMap]);

  if (loading) {
    return <div className="loading-lesson">📚 در حال بارگذاری درس...</div>;
  }

  if (!Component) {
    return <div className="error-lesson">❌ درس مورد نظر یافت نشد</div>;
  }

  return <Component />;
};



const HomeRedirect = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      const routes = {
        student: '/StudentHome',
        teacher: '/TeacherHome',
        parent: '/ParentHome',
        admin: '/AdminHome',
      };
      const target = routes[user?.role];
      if (target) return <Navigate to={target} replace />;
    } catch (e) {}
  }
  return <Navigate to="/login" replace />;
};



// ============================================================
// ✅ تابع RootRedirect اصلاح‌شده
// ============================================================
const RootRedirect = () => {
  const hasSeen = localStorage.getItem('hasSeenOnboarding') === 'true';
  const userStr = localStorage.getItem('user');

  // ✅ اگه کاربر لاگین کرده، بر اساس نقش بفرست به صفحه خودش
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      const roleRoutes = {
        student: '/StudentHome',
        teacher: '/TeacherHome',
        parent: '/ParentHome',
        admin: '/AdminHome',
      };
      const target = roleRoutes[user?.role];
      if (target) return <Navigate to={target} replace />;
    } catch (e) {
      // اگه JSON خراب بود، بیخیال شو
    }
  }

  return <Navigate to={hasSeen ? '/login' : '/onboarding'} replace />;
};

// ============================================================
// ✅ نقش‌های مجاز
// ============================================================
const STUDENT_TEACHER = ['student', 'teacher'];
const STUDENT_ONLY = ['student'];
const TEACHER_ONLY = ['teacher'];
const ALL_ROLES = ['student', 'teacher', 'admin'];
const TEACHER_ADMIN = ['teacher', 'admin'];










// ============================================================
// ✅ ریدایرکت هوشمند /books بر اساس نقش کاربر
// ============================================================
const BooksRedirect = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      // 🆕 معلم دیگر به /teacher/books ریدایرکت نمی‌شود
      //    (معلم مثل دانش‌آموز به صفحه‌ی کتاب‌ها می‌رود و از بنر داخل
      //     CourseVideos به پنل ساخت کلاس هدایت می‌شود)
      if (user?.role === 'admin')   return <Navigate to="/admin/books" replace />;
    } catch (e) {
      // اگه JSON خراب بود، بیخیال شو
    }
  }
  // دانش‌آموز، والدین، معلم یا کاربر ناشناس → صفحه‌ی کتاب‌ها
  return <Books />;
};








// ============================================================
// ✅ کامپوننت اصلی AppRoutes
// ============================================================
export default function AppRoutes() {
const location = useLocation();

  useEffect(() => {
  const timer = setTimeout(async () => {
    try {
      if (!engine.isReady()) await engine.init();
      const projects = dataEngine.project.list();
      let totalMigrated = 0;
      for (const p of projects) {
        const res = dataEngine.version.migrateLegacyLessonIds(p.id);
        totalMigrated += res.migrated || 0;
      }
      if (totalMigrated > 0) {
        console.log(`✅ مهاجرت legacyLessonId: ${totalMigrated} درس اصلاح شد`);
      }
    } catch (e) {
      console.warn('⚠️ migration error:', e);
    }
  }, 1500);

  return () => clearTimeout(timer);
}, []);

  


  return (
    <ExamProvider>
      <GlobalAlertHost />
      <StepQuizSyncListener />
      <UpdateNotification />
      {/*<GameProvider>*/}
      <ErrorBoundary key={location.pathname}>
        <Routes>
          {/* ===== مسیرهای عمومی ===== */}
          <Route path="/" element={<RootRedirect />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login" element={<Login />} />

          {/* ===== مسیرهای عمومی (بدون نیاز به لاگین) ===== */}
          <Route path="/jozwe" element={<JozwePage />} />
          
          {/* 🆕 مسیر ویوئر امن جزوه (نیاز به لاگین) */}
          <Route
            path="/jozwe-view/:materialId"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <JozweViewer />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          
          <Route path="/medals" element={<MedalsPage />} />

          {/* ============================================================
              🏆 مسیر آرنا چالش‌ها (صفحه جدید)
              ============================================================ */}
          <Route
            path="/challenge"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <ChallengeArena />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/StudyTimer"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <StudyTimer />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* ============================================================
              🔥 مسیر جایگزین با نام کاملتر (اختیاری)
              ============================================================ */}
          <Route
            path="/challenge-arena"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <ChallengeArena />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* ===== مسیرهای محافظت‌شده ===== */}
          <Route path="/home" element={<HomeRedirect />} />





          {/* ============================================================
    ✅ مسیرهای اختصاصی هر نقش (Dashboard جدید)
    ============================================================ */}
<Route
  path="/StudentHome"
  element={
    <ProtectedRoute allowedRoles={['student']}>
      <AppLayout>
        <StudentHome />
      </AppLayout>
    </ProtectedRoute>
  }
/>

<Route
  path="/TeacherHome"
  element={
    <ProtectedRoute allowedRoles={['teacher']}>
      <AppLayout>
        <TeacherHome />
      </AppLayout>
    </ProtectedRoute>
  }
/>






<Route path="/payment/callback" element={<PaymentCallbackPage />} />









<Route
  path="/ParentHome"
  element={
    <ProtectedRoute allowedRoles={['parent']}>
      <AppLayout>
        <ParentHome />
      </AppLayout>
    </ProtectedRoute>
  }
/>

<Route
  path="/AdminHome"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminHome />
      </AppLayout>
    </ProtectedRoute>
  }
/>



<Route
  path="/workbook/:bookId"
  element={
    <ProtectedRoute allowedRoles={ALL_ROLES}>
      <AppLayout>
        <WorkbookViewer />
      </AppLayout>
    </ProtectedRoute>
  }
/>



<Route
  path="/free-study/:courseId"
  element={
    <ProtectedRoute allowedRoles={ALL_ROLES}>
      <AppLayout>
        <FreeStudyCourse />
      </AppLayout>
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/categories"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminCategoriesPage />
      </AppLayout>
    </ProtectedRoute>
  }
/>


<Route
  path="/admin/teacher-shelf"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminTeacherShelf />
      </AppLayout>
    </ProtectedRoute>
  }
/>



          <Route
            path="/team-dashboard"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <TeamDashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/parent-dashboard"
            element={
              <ProtectedRoute allowedRoles={['student', 'parent', 'admin']}>
                <AppLayout>
                  <ParentDashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/books"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <BooksRedirect />
                </AppLayout>
              </ProtectedRoute>
            }
          />

<Route path="/payment/return" element={<PaymentReturn />} />

          <Route
            path="/ConvertPage"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <ConvertPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* ✅ مسیر اختصاصی مشاهده‌ی درس‌های دانش‌آموز — از هر نقشی قابل دسترسی */}
<Route
  path="/student-lessons"
  element={
    <ProtectedRoute allowedRoles={ALL_ROLES}>
      <AppLayout>
        <Books />
      </AppLayout>
    </ProtectedRoute>
  }
/>



          <Route
            path="/exams/student"
            element={
              <ProtectedRoute allowedRoles={STUDENT_ONLY}>
                <AppLayout>
                  <Examsstudent />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/exams/teacher"
            element={
              <ProtectedRoute allowedRoles={['teacher', 'admin']}>
                <AppLayout>
                  <Examsteacher />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/ai"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <AI />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/games"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <GamesPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/Lesson-planning"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <LessonPlanning />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route path="/course/:grade/:subject" element={
            <ProtectedRoute allowedRoles={ALL_ROLES}>
              <AppLayout>
                <CourseDetail />
              </AppLayout>
            </ProtectedRoute>
          } />

          <Route path="/course/:grade/:subject/videos" element={
            <ProtectedRoute allowedRoles={ALL_ROLES}>
              <AppLayout>
                <CourseVideos/>
              </AppLayout>
            </ProtectedRoute>
          } />

          <Route
            path="/book/:grade/:subject"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <BookChapters />
                </AppLayout>
              </ProtectedRoute>
            }
          />




{/* 🆕 پنل معلم — مطالعه آزاد */}
<Route
  path="/teacher/free-study"
  element={
    <ProtectedRoute allowedRoles={['teacher']}>
      <AppLayout>
        <TeacherFreeStudy />
      </AppLayout>
    </ProtectedRoute>
  }
/>

{/* 🆕 پنل مدیر — مطالعه آزاد */}
<Route
  path="/admin/free-study"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminFreeStudy />
      </AppLayout>
    </ProtectedRoute>
  }
/>







{/* 🆕 ویرایشگر آزمون مرحله — معلم */}
<Route
  path="/teacher/books/edit/:projectId/quiz/new"
  element={
    <ProtectedRoute allowedRoles={['teacher']}>
      <AppLayout>
        <TeacherStepQuizEditor />
      </AppLayout>
    </ProtectedRoute>
  }
/>

{/* 🆕 اجرای آزمون مرحله — دانش‌آموز */}
<Route
  path="/student/step-quiz/:grade/:subject/:folderName/:lessonId/:stepId"
  element={
    <ProtectedRoute allowedRoles={['student', 'teacher', 'admin']}>
      <AppLayout>
        <StepQuizRunner />
      </AppLayout>
    </ProtectedRoute>
  }
/>


          {/* ============================================================
    ✅ مسیرهای جدید سیستم کتاب‌های داینامیک
    ============================================================ */}

{/* پنل معلم - داشبورد درخواست‌ها و پروژه‌ها */}
<Route
  path="/teacher/books"
  element={
    <ProtectedRoute allowedRoles={['teacher']}>
      <AppLayout>
        <TeacherBooksPage />
      </AppLayout>
    </ProtectedRoute>
  }
/>

{/* ویرایشگر پروژه‌ی معلم */}
<Route
  path="/teacher/books/edit/:projectId"
  element={
    <ProtectedRoute allowedRoles={['teacher']}>
      <AppLayout>
        <TeacherProjectEditor />
      </AppLayout>
    </ProtectedRoute>
  }
/>

{/* پنل مدیر - داشبورد درخواست‌ها و پروژه‌ها */}
<Route
  path="/admin/books"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminBooksPage />
      </AppLayout>
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/upload-pdf"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminUploadPDF />
      </AppLayout>
    </ProtectedRoute>
  }
/>




<Route
  path="/admin/app-versions"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminAppVersions />
      </AppLayout>
    </ProtectedRoute>
  }
/>









{/* بررسی درخواست معلمی (mode: request) */}
<Route
  path="/admin/books/review/:requestId"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminProjectReview />
      </AppLayout>
    </ProtectedRoute>
  }
/>

{/* بررسی پروژه‌ی معلم (mode: project) */}
<Route
  path="/admin/books/review/project/:projectId"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      <AppLayout>
        <AdminProjectReview />
      </AppLayout>
    </ProtectedRoute>
  }
/>












          {/* ============================================================
              ✅ مسیر جدید صفحه مراحل یادگیری (LessonStepsPage)
              ============================================================ */}
          <Route
  path="/Lessons-Gam/:grade/:subject/:folderName/:lessonId"
  element={
    <ProtectedRoute allowedRoles={ALL_ROLES}>
      <AppLayout>
        <LessonStepsPage />
      </AppLayout>
    </ProtectedRoute>
  }
/>




          {/*<Route
            path="/PrivateClassPage"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <PrivateClassPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />*/}



          <Route
          path="/private-class/student"
          element={
            <ProtectedRoute allowedRoles={['student','admin']}>
              <AppLayout>
              <StudentPrivateClassPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/private-class/teacher"
          element={
            <ProtectedRoute allowedRoles={['teacher','admin']}>
              <AppLayout>
              <TeacherPrivateClassPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/private-class/admin"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AppLayout>
              <AdminPrivateClassPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />











        <Route
          path="/WeatherPage"
          element={
            <ProtectedRoute allowedRoles={ALL_ROLES}>
              <AppLayout>
              <WeatherPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />



          




          <Route
            path="/pet"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <GameSanctuary />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/AI-Lessons"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <AILessonGenerator />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/avatars"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <AvatarSettings />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/calendar"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <PersianCalendar />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* ===== مسیر بازی کوییز او کینگ ===== */}
          <Route
            path="/game"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <Game />
              </ProtectedRoute>
            }
          />

          <Route
            path="/game/:mode"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <Game />
              </ProtectedRoute>
            }
          />

          <Route
            path="/game/:mode/:id"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <Game />
              </ProtectedRoute>
            }
          />

          {/* ===== پنل مدیریت سوالات (اختیاری) ===== */}
          <Route
            path="/admin1"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <div>پنل مدیریت در حال ساخت</div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/exams/create/:examId?"
            element={
              <ProtectedRoute allowedRoles={['teacher', 'admin']}>
                <AppLayout>
                  <CreateExam />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/exams/take/:examId"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <TakeExam />
                </AppLayout>
              </ProtectedRoute>
            }
          />





<Route
  path="/exams/public"
  element={
    <ProtectedRoute allowedRoles={ALL_ROLES}>
      <AppLayout>
        <PublicExamsPage />
      </AppLayout>
    </ProtectedRoute>
  }
/>





          <Route
  path="/exams/create-ai"
  element={
    <ProtectedRoute allowedRoles={['teacher', 'admin']}>
      <AppLayout>
        <CreateExamAI />
      </AppLayout>
    </ProtectedRoute>
  }
/>

<Route
  path="/exams/exampdf"
  element={
    <ProtectedRoute allowedRoles={['teacher', 'admin']}>
      <AppLayout>
        <ExamPdfEditor />
      </AppLayout>
    </ProtectedRoute>
  }
/>


          <Route
            path="/coins"
            element={
              <ProtectedRoute allowedRoles={ALL_ROLES}>
                <AppLayout>
                  <CoinsPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* ===== مسیرهای درس‌ها (با ساختار داینامیک) ===== */}
          {/* ریاضی */}
          <Route path="/class1/riazi" element={<RiaziPage />} />
          <Route path="/class2/riazi" element={<RiaziPage2 />} />
          <Route path="/class3/riazi" element={<RiaziPage3 />} />
          <Route path="/class4/riazi" element={<RiaziPage4 />} />
          <Route path="/class5/riazi" element={<RiaziPage5 />} />
          <Route path="/class6/riazi" element={<RiaziPage6 />} />

          {/* فارسی */}
          <Route path="/class1/farsi" element={<FarsiPage />} />
          <Route path="/class2/farsi" element={<FarsiPage2 />} />
          <Route path="/class3/farsi" element={<FarsiPage3 />} />
          <Route path="/class4/farsi" element={<FarsiPage4 />} />
          <Route path="/class5/farsi" element={<FarsiPage5 />} />
          <Route path="/class6/farsi" element={<FarsiPage6 />} />

          {/* علوم */}
          <Route path="/class1/olum" element={<OlumPage />} />
          <Route path="/class2/olum" element={<OlumPage2 />} />
          <Route path="/class3/olum" element={<OlumPage3 />} />
          <Route path="/class4/olum" element={<OlumPage4 />} />
          <Route path="/class5/olum" element={<OlumPage5 />} />
          <Route path="/class6/olum" element={<OlumPage6 />} />

          {/* قرآن */}
          <Route path="/class1/ghoran" element={<GhoranPage />} />
          <Route path="/class2/ghoran" element={<GhoranPage2 />} />
          <Route path="/class3/ghoran" element={<GhoranPage3 />} />
          <Route path="/class4/ghoran" element={<GhoranPage4 />} />
          <Route path="/class5/ghoran" element={<GhoranPage5 />} />
          <Route path="/class6/ghoran" element={<GhoranPage6 />} />

          {/* هدیه */}
          <Route path="/class2/hedye" element={<HedyePage2 />} />
          <Route path="/class3/hedye" element={<HedyePage3 />} />
          <Route path="/class4/hedye" element={<HedyePage4 />} />
          <Route path="/class5/hedye" element={<HedyePage5 />} />
          <Route path="/class6/hedye" element={<HedyePage6 />} />

          {/* مطالعات */}
          <Route path="/class3/motaleat" element={<MotaleatPage3 />} />
          <Route path="/class4/motaleat" element={<MotaleatPage4 />} />
          <Route path="/class5/motaleat" element={<MotaleatPage5 />} />
          <Route path="/class6/motaleat" element={<MotaleatPage6 />} />

          {/* ===== فصل‌های فارسی اول (با LazyLoad) ===== */}
          {Object.keys(farsiLessons).map((id) => (
            <Route
              key={`farsi-${id}`}
              path={`/classroom/class1/farsi/lesson1/review${id}`}
              element={
                <ProtectedRoute allowedRoles={ALL_ROLES}>
                  <Suspense fallback={<div className="loading-lesson">📚 در حال بارگذاری...</div>}>
                    <LessonLoader lessonMap={farsiLessons} lessonId={parseInt(id)} />
                  </Suspense>
                </ProtectedRoute>
              }
            />
          ))}

          {/* ===== فصل‌های علوم اول (با LazyLoad) ===== */}
          {Object.keys(olumLessons).map((id) => (
            <Route
              key={`olum-${id}`}
              path={`/classroom/class1/olum/lesson1/review${id}`}
              element={
                <ProtectedRoute allowedRoles={ALL_ROLES}>
                  <Suspense fallback={<div className="loading-lesson">📚 در حال بارگذاری...</div>}>
                    <LessonLoader lessonMap={olumLessons} lessonId={parseInt(id)} />
                  </Suspense>
                </ProtectedRoute>
              }
            />
          ))}

          {/* ===== فصل‌های قرآن اول (با LazyLoad) ===== */}
          {Object.keys(ghoranLessons).map((id) => (
            <Route
              key={`ghoran-${id}`}
              path={`/classroom/class1/ghoran/lesson1/review${id}`}
              element={
                <ProtectedRoute allowedRoles={ALL_ROLES}>
                  <Suspense fallback={<div className="loading-lesson">📚 در حال بارگذاری...</div>}>
                    <LessonLoader lessonMap={ghoranLessons} lessonId={parseInt(id)} />
                  </Suspense>
                </ProtectedRoute>
              }
            />
          ))}

          {/* ===== فصل‌های ریاضی اول (با LazyLoad) ===== */}
          {Object.keys(riaziLessons).map((id) => (
            <Route
              key={`riazi-${id}`}
              path={`/classroom/class1/riazi/lesson1/review${id}`}
              element={
                <ProtectedRoute allowedRoles={ALL_ROLES}>
                  <Suspense fallback={<div className="loading-lesson">📚 در حال بارگذاری...</div>}>
                    <LessonLoader lessonMap={riaziLessons} lessonId={parseInt(id)} />
                  </Suspense>
                </ProtectedRoute>
              }
            />
          ))}

          {/* ===== مسیرهای ناشناخته ===== */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </ErrorBoundary>
      {/*</GameProvider>*/}
    </ExamProvider>
  );
}